export const LocalStorageConstants = {
    userKey: "CURRENT_USER",
    language: "LANGUAGE",
    accessToken: "ACCESS_TOKEN",
    refreshToken: "REFRESH_TOKEN",
    rememberMe: "REMEMBER_ME",
    selectedOrg: "SELECTED_ORG",
    selectedRisk: "SELECTED_RISK",
    selectedParameter: "SELECTED_PARAMETER",
    selectedDateRange: "SELECTED_DATE_RANGE",
    deviceName: "DEVICE_NAME",
    dashboardMapViewSettings: "DASHBOARD_MAP_VIEW_SETTINGS",
    viewAsLabels: "VIEW_AS_LABELS",
    viewAsEndedNotice: "VIEW_AS_ENDED_NOTICE",
} as const;

export const TEMPLATE_EDITOR_TOUR_SEEN_PREFIX = 'TEMPLATE_EDITOR_TOUR_SEEN_';
